module.exports = __webpack_public_path__ + "static/media/1.f3ad4728.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/7019/1.jpg
// module id = 707
// module chunks = 0